import getUserLogic from "./getUserLogic";
import getUserFailLogic from "./getUserFailLogic";
import createUserLogic from "./createUserLogic";
import selectUser from "./selectUser";

export default [...getUserLogic, ...getUserFailLogic, ...createUserLogic, ...selectUser];
